import { get } from 'lodash';
import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';
import tableExternalLinks from '../tableExternalLinks';
import tableLogMonitor from '../tableLogMonitor';
import tableLogContentLifeCycleMonitor from '../tableLogContentLifeCycleMonitor';
export default {
  title: 'Content Life Cycle',
  attributeName: 'contentLifeCycleLogs',    
  websocketChannel: 'live-content-lifecycle-liveId',
  websocketSessionParams: ['liveId'],
  websocketItem: 'tableContentLifeCycleMonitor',
  sessionParams: [],
  idAttribute: 'id',
  fields: [
    
    {
      label: 'Table Monitor',
      attributeName: 'tableContentLifeCycle',
      type: FormInputTypes.TABLE,
      mode:'NORMAL',
      helpText: '',
      configFile: tableLogContentLifeCycleMonitor,
    },  
    {
      attributeName: 'downloadCSV',
      type: FormInputTypes.BUTTON_FORM,
      mode:'button',
      actionUrl:'live/logs/contentLifeCycleExport',
      actionParams: ['id'],
      actionIsDownload: true,
      label: 'Export Table',
      className:'ml-3 float-left download'
    },
  ],
};
